import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useIntl } from 'react-intl';

import ListSubItem from '../ListSubItem';
import { ListSubItemTextProps } from '../ListSubItemText';

import { Body1 } from '../Typography';

import styles from './index.module.scss';

export interface ListItemTextProps {
  icon: JSX.Element;
  text: string;
  subItems?: ListSubItemTextProps[];
}

const ListItemText: React.FC<ListItemTextProps> = ({
  icon,
  text,
  subItems,
}) => {
  const intl = useIntl();

  const listItemText = intl.formatMessage({
    id: text,
  });

  return (
    <>
      <div className={styles.wrapper}>
        {icon}

        <div className={styles.textWrapper}>
          <Markdown
            components={{
              p: ({ node, children, ...props }) => (
                <Body1 {...props}>{children}</Body1>
              ),
            }}
            rehypePlugins={[rehypeRaw as any]}
          >
            {listItemText}
          </Markdown>
        </div>
      </div>

      {subItems && subItems.length > 0 && (
        <ListSubItem subItems={subItems} className={styles.subItems} />
      )}
    </>
  );
};

export default ListItemText;
